import { createFileRoute, Link } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";
import { PageShell } from "@/components/site/PageShell";
import { CATEGORIES } from "@/lib/categories";

export const Route = createFileRoute("/$lang/categories")({
  head: ({ params }) => ({
    meta: [
      { title: "Categories — MadCaptains" },
      { name: "description", content: "Twelve forms of harassment recorded across the archive." },
      { property: "og:title", content: "Categories — MadCaptains" },
      { property: "og:description", content: "Twelve forms of harassment recorded across the archive." },
      { property: "og:url", content: `/${params.lang}/categories` },
    ],
    links: [{ rel: "canonical", href: `/${params.lang}/categories` }],
  }),
  component: CategoriesIndex,
});

function CategoriesIndex() {
  const { lang, t } = useI18n();
  return (
    <PageShell eyebrow="Taxonomy" title={t.page_categories_h1} lead={t.page_categories_lead}>
      <ol className="divide-y divide-border border-y border-border">
        {CATEGORIES.map((c, i) => (
          <li key={c.slug}>
            <Link
              to="/$lang/categories/$slug"
              params={{ lang, slug: c.slug }}
              className="group flex items-baseline gap-4 px-1 py-4 hover:bg-card/50"
            >
              <span className="w-8 text-right font-display text-sm text-muted-foreground tabular-nums">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex-1">
                <span className="block text-base">{lang === "ru" ? c.label.ru : c.label.en}</span>
                <span className="block text-xs text-muted-foreground">
                  Signal flag · {c.flag.toUpperCase()}
                </span>
              </span>
              <span className="text-xs text-muted-foreground group-hover:text-foreground">→</span>
            </Link>
          </li>
        ))}
      </ol>
    </PageShell>
  );
}